import { DVIRTemplate, DVIRTemplateQuestion } from "../../../models";

// Simple question parser for included data (without template_count)
const parseIncludedQuestion = (data: any) => {
  return {
    id: data.id,
    questionText: data.attributes.question_text,
    questionType: data.attributes.question_type,
  };
};

export const getDVIRTemplate = (
  data: any,
  included: any[] = []
): DVIRTemplate => {
  const template: DVIRTemplate = {
    id: data.id,
    name: data.attributes.name,
    description: data.attributes.description,
    isActive: data.attributes.is_active,
    templateType: data.attributes.template_type,
    templateQuestions: [],
  };

  // Process included data if available
  if (included && included.length > 0) {
    // Create maps for quick lookup using the simpler parser
    const questionsMap = new Map();
    included
      .filter((item) => item.type === "dvir_questions")
      .forEach((item) => {
        const question = parseIncludedQuestion(item);
        questionsMap.set(question.id, question);
      });

    // Get template questions and enhance them with question details
    const templateQuestions = included
      .filter((item) => item.type === "dvir_template_questions")
      .map((item) => {
        const templateQuestion = getDVIRTemplateQuestion(item);
        const question = questionsMap.get(templateQuestion.questionId);

        if (question) {
          return {
            ...templateQuestion,
            questionText: question.questionText,
            questionType: question.questionType,
          };
        }

        // Fallback if question not found in included data
        return {
          ...templateQuestion,
          questionText: "",
          questionType: "boolean" as const,
        };
      })
      .sort((a, b) => a.orderPosition - b.orderPosition);

    template.templateQuestions = templateQuestions;
  }

  return template;
};

export const getDVIRTemplates = (data: any): DVIRTemplate[] => {
  return data.map((item: any) => getDVIRTemplate(item));
};

export const getDVIRTemplateQuestion = (data: any): DVIRTemplateQuestion => {
  return {
    id: data.id,
    templateId: data.attributes.template_id,
    questionId: data.attributes.question_id,
    isRequired: data.attributes.is_required,
    orderPosition: data.attributes.order_position,
    // These will be populated by the template normalizer when processing included data
    questionText: "",
    questionType: "boolean",
  };
};

export const getDVIRTemplateQuestions = (data: any): DVIRTemplateQuestion[] => {
  return data.map(getDVIRTemplateQuestion);
};
